import { render, staticRenderFns } from "./DomainTagList.vue?vue&type=template&id=8ca60840"
import script from "./DomainTagList.vue?vue&type=script&lang=js"
export * from "./DomainTagList.vue?vue&type=script&lang=js"
import style0 from "./DomainTagList.vue?vue&type=style&index=0&id=8ca60840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports